<h1 mat-dialog-title>Pull File</h1>
<mat-dialog-content>
  <h3>Do you want to Pull the file</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onRecall()">
      Pull
    </button>
  </div>
</mat-dialog-actions>
